const SvgIcon = ({size = '24', color = '#fff' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    version="1.1"
    viewBox="0 0 24 24"
  >
    <path
      fill={color}
      stroke="none"
      strokeWidth="2.4"
      d="M11.995 0a12.9 12.9 0 0 0-8.918 3.626l-.014.014L.352 6.352a1.2 1.2 0 0 0 0 1.696 1.2 1.2 0 0 0 1.696 0l2.698-2.697A10.5 10.5 0 0 1 12 2.4c5.316 0 9.6 4.284 9.6 9.6a1.2 1.2 0 0 0 1.2 1.2A1.2 1.2 0 0 0 24 12c0-6.613-5.387-12-12-12z"
      color={color}
    ></path>
    <path
      fill={color}
      stroke="none"
      strokeWidth="2.4"
      d="M1.2 0A1.2 1.2 0 0 0 0 1.2v6a1.2 1.2 0 0 0 1.2 1.2h6a1.2 1.2 0 0 0 1.2-1.2A1.2 1.2 0 0 0 7.2 6H2.4V1.2A1.2 1.2 0 0 0 1.2 0"
      color={color}
    ></path>
    <path
      fill={color}
      stroke="none"
      strokeWidth="2.4"
      d="M1.2 10.8A1.2 1.2 0 0 0 0 12c0 6.613 5.387 12 12 12h.005a12.9 12.9 0 0 0 8.918-3.626l.014-.014 2.711-2.712a1.2 1.2 0 0 0 0-1.696 1.2 1.2 0 0 0-1.696 0l-2.698 2.697A10.5 10.5 0 0 1 12 21.6 9.58 9.58 0 0 1 2.4 12a1.2 1.2 0 0 0-1.2-1.2"
      color={color}
    ></path>
    <path
      fill={color}
      stroke="none"
      strokeWidth="2.4"
      d="M16.8 15.6a1.2 1.2 0 0 0-1.2 1.2 1.2 1.2 0 0 0 1.2 1.2h4.8v4.8a1.2 1.2 0 0 0 1.2 1.2 1.2 1.2 0 0 0 1.2-1.2v-6a1.2 1.2 0 0 0-1.2-1.2z"
      color={color}
    ></path>
  </svg>
);

export default SvgIcon;
